<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             :rules="dataRule"
             ref="dataForm">
      <div class="location-layout">
        <el-row class="row-mar-l">
          <!-- 职位代码 -->
          <el-col :span="6">
            <el-form-item prop="positionCode"
                          :label="$t('position.positionCode')">
              <el-input v-model="dataForm.positionCode"
                        :placeholder="$t('position.positionCodeMessage')"
                        :disabled="isDisabled"></el-input>
            </el-form-item>
          </el-col>
          <!-- 组织类型 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.orgType')"
                          prop="orgType">
              <el-select v-model="dataForm.orgType"
                         :placeholder="$t('user.select')"
                         @change="orgTypeChange">
                <el-option v-for="(item,index) in newOrgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 职位品牌 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.brandCode')"
                          prop="brandCode"
                          :rules="dataForm.orgType !== '60' ? dataRule.brandCode:
                          { required: true, message: this.$t('validate.required'), trigger: 'change' }">
              <el-select v-model="dataForm.brandCode"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in brandArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 状态 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.status')"
                          prop="status">
              <el-select v-model="dataForm.status"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in statusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 职位中文名称 -->
          <el-col :span="6">
            <el-form-item prop="positionName"
                          :label="$t('position.positionNameCn')">
              <el-input v-model="dataForm.positionName"
                        :placeholder="$t('position.positionNameMessage')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 职位团队分类 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.positionGroupType')"
                          prop="positionGroupType">
              <el-select v-model="dataForm.positionGroupType"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in positionGroupArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 职位分类 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.positionType')"
                          prop="positionType">
              <el-select v-model="dataForm.positionType"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in positionArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 认证分类 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.certificationIds')"
                          prop="certificationIds">
              <el-select v-model="dataForm.certificationIds"
                         collapse-tags
                         multiple
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in certificationIdsArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 关键岗 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.keyPositionFlag')"
                          prop="keyPositionFlag">
              <el-select v-model="dataForm.keyPositionFlag"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in keyPositionFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否候需要能力评估 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.evaluateFlag')"
                          prop="evaluateFlag"
                          :rules="dataForm.orgType !== '60' ? dataRule.evaluateFlag:
                          { required: true, message: this.$t('validate.required'), trigger: 'change' }">
              <el-select v-model="dataForm.evaluateFlag"
                         :placeholder="$t('user.select')"
                         :disabled="allowEvaluateFlag"
                         clearable>
                <el-option v-for="(item,index) in evaluateFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否候选人职位 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.candidateFlag')"
                          prop="candidateFlag"
                          :rules="dataForm.orgType !== '60' ? dataRule.candidateFlag:
                          { required: true, message: this.$t('validate.required'), trigger: 'change' }">
              <el-select v-model="dataForm.candidateFlag"
                         :placeholder="$t('user.select')"
                         @change="changeCandidate"
                         :disabled="allowCandidateFlag"
                         clearable>
                <el-option v-for="(item,index) in candidateFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 对应候选人职位 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.relevantCandidateJobcode')"
                          prop="relevantCandidateJobId"
                          :rules="dataForm.orgType !== '60'|| dataForm.candidateFlag ==='10'|| dataForm.candidateFlag ==='20' ? dataRule.relevantCandidateJobId:
                          { required: true, message: this.$t('validate.required'), trigger: 'change' }">
              <el-select v-model="dataForm.relevantCandidateJobId"
                         :placeholder="$t('user.select')"
                         :disabled="allowRelevantCandidate"
                         @change="changeRelevantCandidateJobcode"
                         clearable>
                <el-option v-for="(item,index) in relevantCandidateArrs"
                           :key="index"
                           :label="item.positionCode + '-' +item.positionName"
                           :value="item.positionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 单店单岗 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.singlePosition')"
                          prop="singlePosition">
              <el-select v-model="dataForm.singlePosition"
                         :placeholder="$t('user.select')"
                         @change="singlePositionChange"
                         clearable
                         :disabled="this.dataForm.orgType !== '60'">
                <el-option v-for="(item,index) in singlePositionArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否TA审批 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.taApprovalFlag')"
                          prop="taApprovalFlag">
              <el-select v-model="dataForm.taApprovalFlag"
                         :placeholder="$t('user.select')"
                         clearable
                         :disabled="true">
                <el-option v-for="(item,index) in taApprovalFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否区域经理审批 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.areaAuditFlag')"
                          prop="areaAuditFlag"
                          :rules="dataForm.orgType !== '60'? dataRule.areaAuditFlag:
                          { required: true, message: this.$t('validate.required'), trigger: 'change' }">
              <el-select v-model="dataForm.areaAuditFlag"
                         :placeholder="$t('user.select')"
                         clearable
                         :disabled="allowAreaAudit">
                <el-option v-for="(item,index) in areaAuditFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- AG关键职位代码 -->
          <el-col :span="6">
            <el-form-item prop="keyPositionCode"
                          :label="$t('position.keyPositionCode')">
              <el-input v-model="dataForm.keyPositionCode"
                        :placeholder="$t('position.agCodeMessage')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 职位属性 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.produceFlag')"
                          prop="produceFlag">
              <el-select v-model="dataForm.produceFlag"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in produceFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 面向客户职位 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.customerFlag')"
                          prop="customerFlag">
              <el-select v-model="dataForm.customerFlag"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in customerFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 需完善简历 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.completeResumeFlag')"
                          prop="completeResumeFlag">
              <el-select v-model="dataForm.completeResumeFlag"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in completeResumeFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否允许设置为管理员职位 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.allowAdminFlag')"
                          prop="allowAdminFlag">
              <el-select v-model="dataForm.allowAdminFlag"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in allowAdminFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- AG关键职位代码 -->
          <!-- <el-col :span="6">
            <el-form-item prop="keyPositionCode"
                          :label="$t('position.keyPositionCode')">
              <el-input v-model="dataForm.keyPositionCode"
                        :placeholder="$t('position.agCodeMessage')"
                        clearable></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row class="row-mar-l">
          <!-- 可设为兼职职位 -->
          <el-col :span="6">
            <el-form-item :label="$t('position.partTimeJobFlag')"
                          prop="partTimeJobFlag">
              <el-select v-model="dataForm.partTimeJobFlag"
                         :placeholder="$t('user.select')"
                         :disabled="!dataForm.orgType || dataForm.orgType === ''"
                         @change="changePosition">
                <el-option v-for="(item,index) in partTimeJobArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 可允许主职职位 -->
          <el-col :span="15">
            <el-form-item :label="$t('position.allowPartJobs')"
                          prop="allowPartJobs"
                          style="width:97% !important"
                          :rules="this.dataForm.partTimeJobFlag === '10' ? dataRule.allowPartJobs:
            [{ required: false, message: this.$t('validate.required'), trigger: 'change' }]">
              <el-select v-model="dataForm.allowPartJobs"
                         multiple
                         filterable
                         collapse-tags
                         reserve-keyword
                         @change="selectAll"
                         :disabled="disAllowPart"
                         :placeholder="$t('user.select')"
                         clearable>
                <el-option v-for="(item,index) in allowPartJobsArr"
                           :key="index"
                           :label="item.positionName"
                           :value="item.positionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="check-already">
              <el-checkbox v-model="checkedAlready"
                           :disabled="dataForm.partTimeJobFlag === '20' || (dataForm.allowPartJobs.length === 0 && !checkedAlready)"
                           @change="checkChange">已选项</el-checkbox>
            </div>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 职位描述 -->
          <el-col :span="24">
            <el-form-item prop="positionDesc"
                          :label="$t('position.positionDesc')"
                          style="width:95% !important">
              <el-input v-model="dataForm.positionDesc"
                        type="textarea"
                        :maxlength="4000"
                        :rows="4"
                        show-word-limit
                        :placeholder="$t('position.positionDesc')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <!-- 职位标签 -->
        <el-row class="row-mar-l">
          <el-col :span="24">
            <el-form-item label=" "
                          prop="tagName"
                          style="width: 100%!important;">
              <tag :checkedList="checkList"
                   :moduleId="moduleId"
                   :brandCode="bussinessTypeChecked"
                   @getBussinessType="getBussinessType"
                   @changeCheckedList="changeCheckedList"
                   ref='tagTree'
                   @fatherMethod="fatherMethod"></tag>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div style="margin-top: 20px">
      <!-- 保存 -->
      <el-button type="primary"
                 class="location-layout"
                 @click="dataFormSubmitHandle()">{{ $t('user.save') }}</el-button>
      <!-- 取消 -->
      <el-button type="button"
                 class="location-layout"
                 @click="back()">{{ $t('user.back') }}</el-button>
    </div>
  </el-card>
</template>
<script>
import Tag from '@/components/tag/index'
import debounce from 'lodash/debounce'
import VueI18n from '@/i18n'
export default {
  components: {
    Tag
  },
  data() {
    let _this = this
    return {
      // 已选项
      checkedAlready: false,
      // 职位代码和是否TA审批不可编辑
      isDisabled: false,
      searchJobType: [],
      oldSearchJobType: [],
      visible: false,
      orgArr: _this.enums['orgType'], // 组织类型
      newOrgType: [],
      positionArr: _this.enums['positionType'], // 职位分类
      brandArr: _this.enums['brandCode'], // 职位品牌
      positionGroupArr: _this.enums['positionGroupType'], // 职位团队分类
      produceFlagArr: _this.enums['produceFlag'], // 职位属性
      customerFlagArr: _this.enums['confirmState'], // 面向客户职位
      certificationIdsArr: _this.enums['certType'], // 认证分类
      statusArr: _this.enums['status'], // 状态
      singlePositionArr: _this.enums['confirmState'], // 单店单岗
      partTimeJobArr: _this.enums['confirmState'], // 可设为兼职职位
      keyPositionFlagArr: _this.enums['confirmState'], // 关键岗
      candidateFlagArr: _this.enums['confirmState'], // 是否候选人职位
      taApprovalFlagArr: _this.enums['confirmState'], // 是否TA审批
      completeResumeFlagArr: _this.enums['confirmState'], // 是否TA审批
      evaluateFlagArr: _this.enums['confirmState'], // 是否需要能力评估
      areaAuditFlagArr: _this.enums['confirmState'], // 是否需要区域经理审批
      allowAdminFlagArr: _this.enums['confirmState'],//是否允许设置为管理员职位
      allowPartJobsArr: [], // 允许兼职岗位
      allowPartJobsAllArr: [], // 全部允许兼职岗位
      addOrUpdateVisible: false,
      dataListLoading: false,
      disAllowPart: true,
      dataListSelections: [],
      checkList: [],
      checkedList: [],
      bussinessTypeChecked: null,
      bussinessTypeId: '',
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      dataForm: {
        taApprovalFlag: '20',
        status: '10',
        singlePosition: '20',
        certificationIds: [],
        allowPartJobs: []
      },
      emptyForm: {
        // 关键岗
        keyPositionFlag: '',
        // 可设为兼职职位
        partTimeJobFlag: '',
        // 职位名称
        positionName: '',
        // 职位代码
        positionCode: '',
        // 组织类型
        orgType: '',
        // 职位分类
        positionType: '',
        // 职位团队分类
        positionGroupType: '',
        // 职位属性
        produceFlag: '',
        // 面向客户职位
        customerFlag: '',
        // 状态
        status: '10',
        // 单店单岗
        singlePosition: '20',
        // 职位品牌
        brandCode: '',
        // 认证分类
        certificationIds: [],
        // 允许兼职职位
        allowPartJobs: [],
        // 职位ID
        positionId: '',
        // 标签ID
        labelId: '',
        // 是否候选人职位
        candidateFlag: '',
        // 是否TA审批
        taApprovalFlag: '20',
        // AG关键职位代码
        keyPositionCode: '',
        // 职位描述
        positionDesc: '',
        // 原始单店单岗状态
        oldSinglePosition: '',
        // 需完善简历
        completeResumeFlag: '20',
        bussinessTypeId: '',
        evaluateFlag: '',
        areaAuditFlag: '',
        relevantCandidateId: ''
      },
      allowRelevantCandidate: false,
      allowAreaAudit: false,
      allowCandidateFlag: false,
      allowEvaluateFlag: false,
      relevantCandidateArrs: [], // 候选人职位
    }
  },
  computed: {
    dataRule() {
      return {
        // 职位名称
        positionName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharactersPosition, trigger: 'blur' },
          { max: 50, message: this.$t('validate.validateLength', { 'handle': '50' }), trigger: 'blur' }
        ],
        // 组织类型
        orgType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 职位分类
        positionType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 职位团队分类
        positionGroupType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 可设为兼职职位
        partTimeJobFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 职位属性
        produceFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 面向客户职位
        customerFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 职位代码
        positionCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 20, message: this.$t('validate.validateLength', { 'handle': '20' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' },
          { validator: this.$validate.isNumOrEn, trigger: 'blur' }
        ],
        // 单店单岗
        singlePosition: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 状态
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // AG关键职位代码
        keyPositionCode: [
          { max: 20, message: this.$t('validate.validateLength', { 'handle': '20' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' },
          { validator: this.$validate.isNumOrEn, trigger: 'blur' }
        ],
        // 是否关键岗位
        keyPositionFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 可允许主职职位
        allowPartJobs: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 是否候选人职位
        candidateFlag: [
          { required: false, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 是否TA审批
        taApprovalFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 职位描述
        positionDesc: [
          { max: 4000, message: this.$t('validate.validateLength', { 'handle': '400' }), trigger: 'blur' }
        ],
        // 职位品牌
        brandCode: [
          { required: false, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 认证分类
        certificationIds: [
          { required: false, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 面向客户职位
        completeResumeFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        //对应候选人职位
        relevantCandidateJobId: [
          { required: false, message: this.$t('validate.required'), trigger: 'change' }
        ],
        //是否区域经理审批
        areaAuditFlag: [
          { required: false, message: this.$t('validate.required'), trigger: 'change' }
        ],
        //是否需要测评
        evaluateFlag: [
          { required: false, message: this.$t('validate.required'), trigger: 'change' }
        ],
        //是否允许设置为管理员职位
        allowAdminFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_POSITION, (data) => {
      this.isDisabled = false
      this.oldSearchJobType[0] = []
      this.allowPartJobsArr = []
      this.allowPartJobsAllArr = []
      this.disAllowPart = true
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
        this.initialization()
      }
    })
    this.$request.get('/sys/commposition/candidatePosition',
      {
        positionId: this.$route.query.positionId
      }).then((res, total, code, data) => {
        this.relevantCandidateArrs = res
        this.relevantCandidateArrs = JSON.parse(JSON.stringify(this.relevantCandidateArrs))
      }).catch(() => { })

  },
  mounted() {
    this.initialization()
    this.newOrgType = JSON.parse(JSON.stringify(this.orgArr))
    if (this.newOrgType.length === 6) {
      // this.newOrgType.splice(3, 2)
      this.newOrgType.splice(4, 1)
    }
  },
  methods: {
    checkChange(val) {
      if (val) { // 已选项
        this.allowPartJobsArr = []
        this.dataForm.allowPartJobs.forEach(item => {
          let entry = this.allowPartJobsAllArr.find(item1 => {
            if (item1.positionId === item) {
              return item1
            }
          })
          this.allowPartJobsArr.push(entry)
        })
      } else { // 全部
        this.allowPartJobsArr = JSON.parse(JSON.stringify(this.allowPartJobsAllArr))
      }
    },
    orgTypeChange() {
      this.dataForm.partTimeJobFlag = '20'
      this.changePosition('20')
      this.getPatrJobsList()
      //this.candidatePosition()
      this.dataForm.candidateFlag = '20'
      this.dataForm.areaAuditFlag = '20'
      this.dataForm.evaluateFlag = '20'
      if (this.dataForm.orgType === '60') {
        this.allowRelevantCandidate = false
        this.allowAreaAudit = false
        this.allowCandidateFlag = false
        this.allowEvaluateFlag = false
      } else {
        this.dataForm.singlePosition = '20'
        // this.dataForm.candidateFlag = '20'
        // this.dataForm.areaAuditFlag = '20'
        // this.dataForm.evaluateFlag = '20'
        this.allowRelevantCandidate = true
        this.allowAreaAudit = true
        this.allowCandidateFlag = true
        this.allowEvaluateFlag = true
        this.dataForm.relevantCandidateJobId = ''
      }
    },
    singlePositionChange(val) {
      if (this.dataForm.positionId) {
        if (val === '10') {
          this.$confirm('请确认该岗位目前是否一个店只有一个用户使用（请慎重修改）？', '确认修改', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(() => {
            this.dataForm.singlePosition = val
            this.oldSinglePosition = val
          }).catch(action => {
            this.dataForm.singlePosition = this.oldSinglePosition
          })
        } else {
          this.oldSinglePosition = val
        }
      }
    },
    // 允许兼职职位change事件，实现全选功能
    selectAll(val) {
      // 用来储存上一次的值，可以进行对比
      const oldVal = this.oldSearchJobType.length === 1 ? this.oldSearchJobType[0] : []
      if (!this.checkedAlready || val.includes(-1) || this.allowPartJobsAllArr.length - 1 === this.dataForm.allowPartJobs.length) {
        // 若是全部选择
        if (val.includes(-1)) {
          const allValues = []
          // 保留所有值
          this.allowPartJobsArr.forEach(item => {
            allValues.push(item.positionId)
          })
          this.dataForm.allowPartJobs = allValues
        }
        // 取消全部选中 上次有 当前没有 表示取消全选
        if (oldVal.includes(-1) && !val.includes(-1)) this.dataForm.allowPartJobs = []
        // 点击非全部选中 需要排除全部选中 以及 当前点击的选项
        // 新老数据都有全部选中
        if (oldVal.includes(-1) && val.includes(-1)) {
          const index = val.indexOf(-1)
          val.splice(index, 1) // 排除全选选项
          this.dataForm.allowPartJobs = val
        }
        // 全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
        if (!oldVal.includes(-1) && !val.includes(-1)) {
          if (val.length === this.allowPartJobsArr.length - 1) this.dataForm.allowPartJobs = [-1].concat(val)
        }
      }
      // 储存当前最后的结果 作为下次的老数据
      this.oldSearchJobType[0] = this.dataForm.allowPartJobs
    },
    // 页面初始化
    initialization() {
      this.$refs.tagTree.getBussinessDefine()
      this.$refs['dataForm'].resetFields()
      this.dataForm = JSON.parse(JSON.stringify(this.emptyForm))
      this.checkList = []
      this.bussinessTypeChecked = null
      // 判断positionId是否为空
      if (this.$route.query.positionId !== undefined) {
        this.isDisabled = true
        this.dataForm.positionId = this.$route.query.positionId
        this.getInfo()
      } else {
        this.isDisabled = false
      }
    },
    changePosition(val) {
      // 兼职职位，允许兼职职位可选
      this.checkedAlready = false
      if (val === '20') {
        this.dataForm.allowPartJobs = []
        this.oldSearchJobType[0] = []
        this.disAllowPart = true
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate('allowPartJobs')
        }
      } else {
        this.selectAll([-1])
        this.disAllowPart = false
      }
    },
    // 获取允许兼职职位列表
    getPatrJobsList() {
      this.$request.get('/sys/commposition/partJobsListSave',
          {
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          this.allowPartJobsAllArr = res
          this.allowPartJobsArr = res
        }).catch(() => { })
      /*
      if (this.dataForm.positionId !== null && this.dataForm.positionId) { // positionId不为空，调用partJobsListUpdate接口
        this.$request.get('/sys/commposition/partJobsListUpdate',
          {
            positionId: this.dataForm.positionId,
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          this.allowPartJobsAllArr = res
          this.allowPartJobsArr = res
        }).catch(() => { })
      } else { // positionId为空，调用partJobsListSave接口
        this.$request.get('/sys/commposition/partJobsListSave',
          {
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          this.allowPartJobsAllArr = res
          this.allowPartJobsArr = res
        }).catch(() => { })
      }*/
    },
    // 获取信息
    getInfo() {
      this.$request.get(`/sys/commposition/info/${this.dataForm.positionId}`).then((res, total, code, data) => {
        // 保留之前的单店单岗状态，取消后将状态置为原来的状态
        this.oldSinglePosition = res.singlePosition
        // 是主要职位，允许兼职职位可选
        if (res.partTimeJobFlag === '20') {
          this.disAllowPart = true
        } else {
          this.disAllowPart = false
        }
        if (res.candidateFlag === '20') {
          this.allowRelevantCandidate = false
        } else {
          this.allowRelevantCandidate = true
        }
        // 相关认证为多选，数据类型为list
        if (data.result.certificationIds !== '' && data.result.certificationIds) {
          data.result.certificationIds = data.result.certificationIds.split(',')
        } else {
          data.result.certificationIds = []
        }
        // 允许兼职职位为多选，数据类型为list
        if (data.result.allowPartJobs !== '' && data.result.allowPartJobs) {
          data.result.allowPartJobs = data.result.allowPartJobs.split(',')
        } else {
          data.result.allowPartJobs = []
        }
        // 遍历res中的允许兼职职位，转化为Number类型数组
        for (let i = 0; i < data.result.allowPartJobs.length; i++) {
          data.result.allowPartJobs[i] = Number(data.result.allowPartJobs[i])
        }
        // 全部岗位删除自己
        /*
        for (let i = 0; i < data.result.allowPartJobs.length; i++) {
          if (data.result.allowPartJobs[i] === data.result.positionId) {
            let index = data.result.allowPartJobs.indexOf(data.result.allowPartJobs[i])
            if (index > -1) {
              data.result.allowPartJobs.splice(index, 1)
            }
          }
        }*/
        this.oldSearchJobType[0] = data.result.allowPartJobs
        // 已选择的标签
        this.checkList = data.result.commLabelVoList ? data.result.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.checkList.forEach(o => {
            o.labelName = o.labelNameCn
          })
        } else {
          this.checkList.forEach(o => {
            o.labelName = o.labelNameEn
          })
        }
        // 已选择的业务类型
        this.bussinessTypeChecked = data.result.bussinessTypeId
        this.dataForm = {
          ...this.dataForm,
          ...data.result
        }
        this.getPatrJobsList()
        //this.candidatePosition()
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch(() => { })
    },
    // 重新勾选业务标签
    fatherMethod() {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    },
    getBussinessType(val) {
      this.dataForm.bussinessTypeId = val
      this.bussinessTypeId = val
    },
    changeCheckedList(array) {
      this.checkList = array
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.dataForm.bussinessTypeId = this.bussinessTypeId
      let tmp = []
      if (this.checkList.length !== 0) {
        this.checkList.forEach(o => {
          tmp.push(o.labelId)
        })
        this.dataForm.labelId = tmp.join(',')
      }
      let dataFormModify = JSON.parse(JSON.stringify(this.dataForm))
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        // if (dataFormModify.positionId !== null && dataFormModify.positionId !== '') {
        //   if (dataFormModify.positionId === dataFormModify.relevantCandidateJobId) {
        //     let message = '对应候选人职位与本职位不能相同'
        //     this.$alert(message, this.$t('prompt.title')).then(() => { }).catch(() => { })
        //     return false
        //   }
        // }
        // 相关认证不为空，逗号分隔
        if (dataFormModify.certificationIds !== undefined) {
          dataFormModify.certificationIds = dataFormModify.certificationIds.join(',')
        }
        // 允许兼职职位不为空，逗号分隔
        if (dataFormModify.allowPartJobs !== undefined) {
          if (dataFormModify.allowPartJobs.includes(-1)) {
            dataFormModify.allowPartJobs = '-1'
          } else {
            dataFormModify.allowPartJobs = dataFormModify.allowPartJobs.join(',')
          }
        }
        this.$request.post(`/sys/commposition/${!dataFormModify.positionId ? 'save' : 'update'}`,
          dataFormModify
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }
          })
        }).catch(() => { })
      })
    }, 5000, { 'leading': true, 'trailing': false }),
    back() {
      // this.tabRemove(this.$store.state.contentTabsActiveName)
      this.$router.push({
        name: 'sys-position'
      })
    },

    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        // this.$router.push({
        //   name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name,
        //   query: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].query
        // })
        this.$router.push({
          name: 'sys-position'
        })
      }
    },

    changeCandidate(val) {
      if (val === '20') {
        this.allowRelevantCandidate = false
        //this.candidatePosition()
      } else {
        this.allowRelevantCandidate = true
        this.dataForm.relevantCandidateJobId = ''
      }
    },
    // candidatePosition(){
    //   this.$request.get('/sys/commposition/candidatePosition').
    //   then((res, total, code, data) => {
    //       this.relevantCandidateArrs = res
    //       this.relevantCandidateArrs = JSON.parse(JSON.stringify(this.relevantCandidateArrs))
    //     }).catch(() => { })
    // }

    changeRelevantCandidateJobcode() {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang='scss' scoped>
.row-mar-l {
  margin-bottom: 10px;
}
.el-select__tags {
  white-space: nowrap;
  overflow: hidden;
}
.check-already {
  margin: 30px 0 0 0;
}
 .el-textarea .el-input__count {
  bottom: -26px !important;
}
</style>
